import {
  FETCH_TRANSACTIONS_REQUEST,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_FAILURE,
  REFUND_TRANSACTION_REQUEST,
  REFUND_TRANSACTION_SUCCESS,
  REFUND_TRANSACTION_FAILURE,
} from '../actions/types';

const initialState = {
  transactions: [],
  loading: false,
  error: null,
  message: '',
  refundStatus: null,
};

export default function transactionReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TRANSACTIONS_REQUEST:
    case REFUND_TRANSACTION_REQUEST:
      return { ...state, loading: true, error: null, refundStatus: null };

    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload,
        message: 'Transactions loaded successfully',
      };

    case FETCH_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        transactions: [],
      };

    case REFUND_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        refundStatus: 'success',
        message: 'Refund processed successfully',
        transactions: state.transactions.map((txn) =>
          txn.paygate_transaction_id === action.payload.paygate_transaction_id
            ? { ...txn, status: 'Refunded' }
            : txn
        ),
      };

    case REFUND_TRANSACTION_FAILURE:
      return {
        ...state,
        loading: false,
        refundStatus: 'failed',
        error: action.payload,
        message: 'Refund failed',
      };

    default:
      return state;
  }
}
